import {IDeviceDto, IDeviceGroupDto} from "./Dto/IDeviceDto";
import RepositoryWorker from "../RepositoryWorker";
import {Store} from "vuex";

export interface EditDeviceGroup {
    id: number|null;
    name: string;
}

export interface AddDevicesToGroupRequest {
    groupId: number;
    deviceList: number[];
}

export interface DeviceGroupMembershipResponse extends IDeviceGroupDto {
    deviceList: { id: number; imei: string }[];
}


class DeviceGroupRepository {
    static getAllDevicesWithGroups(store: Store<any>): Promise<IDeviceDto[]> {
        if (store.state.deviceList) {
            return new Promise(
                (resolve) => {
                    resolve(store.state.deviceList);
                }
            );
        }
        return RepositoryWorker
            .makeGetCallInternal<IDeviceDto[]>('/api/v1/devicegroup/list')
            .then(response => {
                store.commit('updateDeviceList', response);
                return response;
            });
    }

    static findAll(): Promise<IDeviceGroupDto[]> {
        return RepositoryWorker
            .makeGetCallInternal<IDeviceGroupDto[]>('/api/v1/devicegroup');
    }

    static save(deviceGroup: EditDeviceGroup): Promise<IDeviceGroupDto> {
        if (deviceGroup.id) {
            return RepositoryWorker
                .makePostCallInternal<IDeviceGroupDto>('/api/v1/devicegroup', deviceGroup);
        } else {
            return RepositoryWorker
                .makePutCallInternal<IDeviceGroupDto>('/api/v1/devicegroup', deviceGroup);
        }
    }

    static delete(group: IDeviceGroupDto): Promise<void> {
        return RepositoryWorker
            .makeDeleteCallInternal(`/api/v1/devicegroup?group_id=${group.id}`);
    }

    static addDevicesToGroup(request: AddDevicesToGroupRequest): Promise<DeviceGroupMembershipResponse> {
        return RepositoryWorker
            .makePutCallInternal<DeviceGroupMembershipResponse>('/api/v1/devicegroup/device', request);
    }

    static removeDevicesFromGroup(request: AddDevicesToGroupRequest): Promise<DeviceGroupMembershipResponse> {
        return RepositoryWorker
            .makePostCallInternal<DeviceGroupMembershipResponse>('/api/v1/devicegroup/device/delete', request);
    }

}

export default DeviceGroupRepository;
